import { IFee, IServerOrder } from '@rbi-ctg/menu';

import { FEES } from './constants';
import { IGetStandardizedName } from './types';

type FeeFields = Partial<Omit<IFee, 'name' | 'totalCents'>> & {
  readonly name?: IFee['name'] | null;
  readonly totalCents?: IFee['totalCents'] | null;
};

type FeeLike = FeeFields | null | undefined;

export const getStandardizedName = ({ name }: IGetStandardizedName): string =>
  FEES[name as keyof typeof FEES] ?? name;

export const capitalizeFeeName = (feeName: string): string =>
  feeName.replace(/\S+/g, word => `${word.charAt(0).toUpperCase()}${word.slice(1)}`);

export const getFeesByGroup = (fees?: ReadonlyArray<FeeLike> | null) => {
  return (fees ?? []).reduce<Record<string, number>>((acc, val) => {
    if (!val?.name || !val.totalCents) {
      return acc;
    }

    acc[val.name] = (acc[val.name] ?? 0) + val.totalCents;

    return acc;
  }, {});
};

enum DONATIONS {
  ROUND_UP = '',
}
// TODO this donation code will likely evolve as we implement. this was stolen from rGuest for the mparticle -> amplitude migration
export const getRoundUpDonations = (serverOrder: IServerOrder | null) =>
  serverOrder?.cart?.donations?.find(({ name }) => name === DONATIONS.ROUND_UP);
